import React from 'react';
export interface ImagingSettingsCardProps {
  imageSettings: any;
  header: string;
}
const ImagingSettingsCard = (props: ImagingSettingsCardProps) => {
  const { imageSettings, header } = props;

  return (
    <div id='commandpanel-imagingsettingscard-wrapper' className="p-2">
      {imageSettings?.length ? (
        <div id='commandpanel-imagingsettingscard-container' className="border p-1 rounded-sm">
          <div id={`commandpanel-imagingsettingscard-${header}`} className="font-bold text-xl">{header}</div>
          {imageSettings.map((image, i) => (
            <div id={`commandpanel-imagingsettingscard-item-${i}`} key={`imageSetting-${i}`} className="flex flex-row">
              <div id={`commandpanel-imagingsettingscard-imagename-${image.name}`} className="w-1/2">{image.name}</div>
              <div id={`commandpanel-imagingsettingscard-value-${image.value}`} className="w-1/2">{image.value}</div>
            </div>
          ))} 
        </div>
      ) : null}
    </div>
  );
};

export default ImagingSettingsCard;
